<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <path d="M6.75 12.15 3.6 9l-1.05 1.05 4.2 4.2 9-9L14.7 4.2l-7.95 7.95Z"/>
</svg>
